import { axios } from "utils";

import { PUBLIC_MANURE_ADDITIVES_URL as endpoint } from "consts";

import { ManureAdditive } from "models";

export const getManureAdditives = async ({ enabled }: { enabled?: boolean } = {}): Promise<ManureAdditive[]> => axios.get(endpoint, { params: { enabled } });
